// extracted by mini-css-extract-plugin
module.exports = {"stub":"stub-1QNwK","stub-anim":"stub-anim-21SRR"};